import React from 'react';
import ManageBrandForm from '../Forms/manage_brand_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
    { label: 'Address', field: 'Address' },
    { label: 'Contact No.', field: 'ContactNo' },
    { label: 'Roll/Others', field: 'RollOrOthers' },
];

function Manage_brand() {
    return (
        <ManageDataPage
            title="Manage Brand"
            endpoint="get_manage_brand_table"
            columns={COLUMNS}
            idKey="BrandID"
            FormComponent={ManageBrandForm}
            searchPlaceholder="Search name, address, contact..."
        />
    );
}

export default Manage_brand;
